// extracted by mini-css-extract-plugin
export default {"anchor":"ReportSubChapterBlock_anchor__wqb2Y","heading":"ReportSubChapterBlock_heading__3LOk-","contentArea":"ReportSubChapterBlock_contentArea__M-RKH"};